import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormatSimple } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'

export const Columns = (
  onClick: (text: string, t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    // {
    //   title: '门店名称',
    //   dataIndex: 'tenantMaterialsCatalogId',
    //   align: 'center',
    //   width: '8rem',
    //   ellipsis: true,
    // },
    {
      title: '配置地点',
      dataIndex: 'location',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.location ? t.location : '-'
      },
    },
    {
      title: '设备编号',
      dataIndex: 'deviceNumber',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.deviceNumber ? t.deviceNumber : '-'
      },
    },
    {
      title: '设备名称',
      dataIndex: 'deviceName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.deviceName ? t.deviceName : '-'
      },
    },
    {
      title: '规格型号',
      dataIndex: 'model',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.model ? t.model : '-'
      },
    },
    {
      title: '出厂批号/编号',
      dataIndex: 'factoryNumber',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.factoryNumber ? t.factoryNumber : '-'
      },
    },
    {
      title: '生产日期',
      dataIndex: 'productionDate',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.productionDate
          ? moment(t?.productionDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '购置日期',
      dataIndex: 'purchaseDate',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.purchaseDate
          ? moment(t?.purchaseDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '报废日期',
      dataIndex: 'scrapDate',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.scrapDate
          ? moment(t?.scrapDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '启用日期',
      dataIndex: 'startDate',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.startDate
          ? moment(t?.startDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '厂家',
      dataIndex: 'factoryName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.factoryName ? t.factoryName : '-'
      },
    },
    {
      title: '供货企业',
      dataIndex: 'supplierEnterprise',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.supplierEnterprise ? t.supplierEnterprise : '-'
      },
    },
    {
      title: '联系人',
      dataIndex: 'contactPerson',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.contactPerson ? t.contactPerson : '-'
      },
    },
    {
      title: '联系电话',
      dataIndex: 'contactPhone',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.contactPhone ? t.contactPhone : '-'
      },
    },
    {
      title: '数量',
      dataIndex: 'quantity',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.quantity ? t.quantity : '-'
      },
    },
    {
      title: '价格',
      dataIndex: 'price',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.price ? t.price?.toFixed(5) : '-'
      },
    },
    {
      title: '金额',
      dataIndex: 'amount',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.amount ? t.amount?.toFixed(2) : '-'
      },
    },
    {
      title: '生产许可证编号',
      dataIndex: 'productionLicenseNumber',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.productionLicenseNumber ? t.productionLicenseNumber : '-'
      },
    },
    {
      title: '注册证号',
      dataIndex: 'registrationCertificateNumber',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.registrationCertificateNumber
          ? t.registrationCertificateNumber
          : '-'
      },
    },
    {
      title: '执行标准号',
      dataIndex: 'executionStandardNumber',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.executionStandardNumber ? t.executionStandardNumber : '-'
      },
    },
    {
      title: '养护使用人',
      dataIndex: 'maintenanceUser',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.maintenanceUser ? t.maintenanceUser : '-'
      },
    },
    {
      title: '管理员',
      dataIndex: 'administrator',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.administrator ? t.administrator : '-'
      },
    },
    {
      title: '一般检定周期',
      dataIndex: 'generalInspectionCycle',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.generalInspectionCycle ? t.generalInspectionCycle : '-'
      },
    },
    {
      title: '强检周期',
      dataIndex: 'mandatoryInspectionCycle',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.mandatoryInspectionCycle ? t.mandatoryInspectionCycle : '-'
      },
    },
    {
      title: '用途',
      dataIndex: 'usage',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.usage ? t.usage : '-'
      },
    },
    {
      title: '使用年限',
      dataIndex: 'serviceLife',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.serviceLife ? t.serviceLife : '-'
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.remark ? t.remark : '-'
      },
    },
  ]
}
